import React from 'react';

import styled from 'styled-components';

import { INutritionInfo } from '@rbi-ctg/menu';

import { SanityNutritionItem } from './types';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Name = styled.span`
  text-transform: capitalize;
`;

type NutritionItemProps = {
  nutritionItem: SanityNutritionItem;
  nutritionInfo: INutritionInfo;
  roundNutritionValue: (val: number) => number;
};

export const NutritionItem: React.FC<NutritionItemProps> = ({
  nutritionInfo,
  nutritionItem,
  roundNutritionValue,
  ...props
}) => {
  const primaryItemValue = nutritionInfo[nutritionItem.nutritionKey ?? ''];
  const primaryItemUnit = nutritionItem.unit?.locale;
  const primaryItemName = nutritionItem.name?.locale;
  if (primaryItemValue === undefined || !primaryItemUnit || !primaryItemName) {
    return null;
  }

  const roundedPrimaryItemValue = roundNutritionValue(primaryItemValue);

  const firstAdditionalItem = nutritionItem.additionalItems?.[0];
  const additionalItemUnit = firstAdditionalItem?.unit?.locale;
  const additionalItemValue = nutritionInfo[firstAdditionalItem?.nutritionKey ?? ''];

  const roundedAdditionalItemValue =
    additionalItemValue !== undefined ? roundNutritionValue(additionalItemValue) : undefined;

  return (
    <Container {...props}>
      <Name>{primaryItemName}</Name>
      <span>
        <span data-testid="primary-item-nutrition-value">
          {roundedPrimaryItemValue}
          {primaryItemUnit}
        </span>
        {firstAdditionalItem && (
          <span data-testid="additional-item-nutrition-value">
            {' '}
            / {roundedAdditionalItemValue}
            {additionalItemUnit}
          </span>
        )}
      </span>
    </Container>
  );
};
